<template>

  <div>
    <div class="title pt-2 required-field">
      <span>{{FORM_LABELS.NAME_OF_SUPPLIER}}</span>
    </div>
    <div class="mb-4 my-2">
      <supplier-auto-complete
          :isRequired="true"
          :currentSelection="nonPOPaymentData.supplierName"
          @onItemSelected="assignSupplierDetailsFromSupplierName"
          @uniqueCompanyCodeList="assignUniqueCompanyCodeList"
          :is-form-non-po="true"
          :is-supplier-fetched-from-supplier-id="isSupplierFetchedFromSupplierId"
          @noAutoCompleteResults="resetSupplierDetails"
          :key="supplierNameKey"
      />
      <span
          class="text-danger input-error-text"
          v-if="validSupplierNameWarningMessage">Please enter a valid Supplier name or select one from the dropdown.
    </span>
      <show-errors :for-item="'nonPOPaymentData.supplierName'" :formErrors="errors" :max-length="70" :field-name="'Supplier name'" />
    </div>

    <div class="title pt-2 required-field">
      <span>{{FORM_LABELS.SUPPLIER_ID}}</span>
    </div>
    <div class="mb-4 my-2">
      <SupplierIDInput
          :form-type="formType"
          :currentSelection="nonPOPaymentData.supplierNumber"
          :supplierID="nonPOPaymentData.supplierNumber"
          @uniqueCompanyCodeList="assignUniqueCompanyCodeList"
          @supplierIdMaxLengthExceeded="showWarningForMaxLengthExceeded"
          @noAutoCompleteResults="resetSupplierDetails"
          @onSupplierIDEntered="assignSupplierDetailsFromSupplierId($event)"
          :key="supplierIdKey"
      />
      <span
          class="text-danger input-error-text"
          v-if="validSupplierIdWarningMessage">Please enter a valid Supplier Id or select one from the dropdown.
    </span>
      <show-errors :for-item="'nonPOPaymentData.supplierNumber'" :formErrors="errors" :max-length="70" :field-name="'Supplier name'" />
    </div>

    <div class="title mt-3 required-field">
      <span>{{ FORM_LABELS.COMPANY_AND_CODE_NAME }}</span>
    </div>

    <div class="my-2">
      <div class="item select-style">
        <model-list-select
            :list="filteredAutocompleteCompanyCodeAndNameList"
            :optionValue="'value'"
            :optionText="'text'"
            name="nonPOPaymentData.companyCode"
            @input="setCompanyCodeAndText"
            v-validate="'required'"
            v-model="companyCodeAndName"
            id="companyCodeAndNameList"
        />
        <show-errors :for-item="'nonPOPaymentData.companyCode'" :formErrors="errors" :field-name="FORM_LABELS.COMPANY_AND_CODE_NAME" />
      </div>
    </div>
  </div>

</template>

<script>
import SupplierAutoComplete from "@/components/SupplierAutoComplete";
import { ModelListSelect } from "vue-search-select";
import SupplierIDInput from "./SupplierIDInput";
import PaymentFormsMixin from "../../../mixins/PaymentFormsMixin";
import {mapGetters, mapMutations} from "vuex";
import CONSTANTS from "@/store/constants";
import FORM_LABELS from "@/store/FormLabels";

export default {
  name: "NonPOAutocomplete",
  components: {SupplierIDInput,SupplierAutoComplete,ModelListSelect},
  inject: ["$validator"],
  mixins:[PaymentFormsMixin],
  computed:{
    ...mapGetters(['nonPOPaymentData','autocompleteCompanyCodeAndNameList','adminDataList']),
    filteredAutocompleteCompanyCodeAndNameList() {
      let filteredAutocompleteCompanyCodeAndNameList = this.autocompleteCompanyCodeAndNameList
      if(filteredAutocompleteCompanyCodeAndNameList && filteredAutocompleteCompanyCodeAndNameList.length > 0) {
        filteredAutocompleteCompanyCodeAndNameList = filteredAutocompleteCompanyCodeAndNameList.sort((a, b) => (a.text > b.text) ? 1 : -1)
      }
      return filteredAutocompleteCompanyCodeAndNameList
    }
  },
  data(){
    return{
      companyCodeAndName: '',
      validSupplierNameWarningMessage: false,
      validSupplierIdWarningMessage: false,
      FORM_LABELS: FORM_LABELS,
      formType: CONSTANTS.NON_PO_BASED_API_FORM_TYPE,
      supplierIdKey: 0,
      supplierNameKey: 0,
      isSupplierFetchedFromSupplierId: false
    }
  },
  mounted() {
    this.setDefaultCompanyCodeAndName()
    this.setCompanyCodeAndTextField(this.nonPOPaymentData)
  },
  methods: {
    ...mapMutations(["setAutocompleteCompanyCodeAndNameList"]),
    showWarningForMaxLengthExceeded(){
      this.validSupplierIdWarningMessage = true
    },
    assignUniqueCompanyCodeList(event){
      this.companyCodeAndName = ''
      this.setAutocompleteCompanyCodeAndNameList(JSON.parse(JSON.stringify(event)))
    },
    setDefaultCompanyCodeAndName() {
      let defaultCompanyCodeAndName = []
      if(this.nonPOPaymentData.companyCode && this.nonPOPaymentData.companyCodeText) {
        defaultCompanyCodeAndName.push({value: this.nonPOPaymentData.companyCode, text: `${this.nonPOPaymentData.companyCode} - ${this.nonPOPaymentData.companyCodeText}`})
      } else {
        this.adminDataList.companyCodeList.forEach(company => {
          defaultCompanyCodeAndName.push({value: company.companyCode, text: `${company.companyCode} - ${company.companyName}`})
        })
      }
      this.setAutocompleteCompanyCodeAndNameList(defaultCompanyCodeAndName)
    },
    resetSupplierDetails(event){
      this.companyCodeAndName = ''
      this.nonPOPaymentData.companyCode = ''
      this.nonPOPaymentData.companyCodeText = ''
      this.nonPOPaymentData.supplierNumber = ''
      this.nonPOPaymentData.supplierName = ''
      this.supplierIdKey++
      this.supplierNameKey++
      if (event === FORM_LABELS.NAME_OF_SUPPLIER){
        this.validSupplierNameWarningMessage = true
      }else this.validSupplierIdWarningMessage = true
    },
    setCompanyCodeAndTextField(nonPOPaymentData) {
      let companyCode = this.autocompleteCompanyCodeAndNameList.find(company => company.value === nonPOPaymentData.companyCode)
      this.companyCodeAndName = companyCode ? companyCode.value : ''
    },
    setCompanyCodeAndText(event) {
      let companyCode = this.adminDataList.companyCodeOptions.find(company => company.text === event)
      this.nonPOPaymentData.companyCode = companyCode.text
      let companyCodeText = this.adminDataList.companyCodeTextOptions.find(company => company.value === companyCode.value)
      this.nonPOPaymentData.companyCodeText = companyCodeText.text
    },
    assignSupplierDetailsFromSupplierId(event) {
      let supplierDetails = JSON.parse(JSON.stringify(event))
      this.isSupplierFetchedFromSupplierId = true
      this.nonPOPaymentData.supplierName = supplierDetails.supplierName
      this.nonPOPaymentData.supplierNumber = supplierDetails.supplierNumber
      this.supplierNameKey++
      this.validSupplierIdWarningMessage = false
      if (this.validSupplierNameWarningMessage)
        this.validSupplierNameWarningMessage = false
    },
    assignSupplierDetailsFromSupplierName(event) {
      let supplierDetails = JSON.parse(JSON.stringify(event))
      if(supplierDetails.filteredName === supplierDetails.supplierName) {
        this.nonPOPaymentData.supplierName = supplierDetails.filteredName
        this.nonPOPaymentData.supplierNumber = supplierDetails.supplierNumber
        this.supplierIdKey++
        this.validSupplierNameWarningMessage = false
        if (this.validSupplierIdWarningMessage)
          this.validSupplierIdWarningMessage = false
      }
    }
  }
}
</script>

<style scoped>

.select-style >>> .ui.selection.dropdown .menu  {
  max-height: 150px;
}

</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>